
import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { User, Phone, Calendar, MapPin } from 'lucide-react';
import type { Patient } from '@/types';

interface PatientCardProps {
  patient: Patient;
}

const PatientCard: React.FC<PatientCardProps> = ({ patient }) => {
  return (
    <Card className="hover:shadow-md transition-shadow">
      <CardContent className="p-4">
        <div className="flex justify-between items-start">
          <div className="flex-1">
            <div className="flex items-center space-x-3 mb-2">
              <div className="bg-blue-100 p-2 rounded-full">
                <User className="h-4 w-4 text-blue-600" />
              </div>
              <div>
                <h3 className="font-semibold text-lg">
                  {patient.first_name} {patient.last_name}
                </h3>
                <p className="text-sm text-gray-500">
                  MRN: {patient.medical_record_number}
                </p>
              </div>
            </div>
            
            <div className="grid grid-cols-1 md:grid-cols-3 gap-2 text-sm text-gray-600">
              {patient.date_of_birth && (
                <div className="flex items-center space-x-1">
                  <Calendar className="h-3 w-3" />
                  <span>Born: {new Date(patient.date_of_birth).toLocaleDateString()}</span>
                </div>
              )}
              {patient.phone && (
                <div className="flex items-center space-x-1">
                  <Phone className="h-3 w-3" />
                  <span>{patient.phone}</span>
                </div>
              )}
              {patient.address && (
                <div className="flex items-center space-x-1">
                  <MapPin className="h-3 w-3" />
                  <span className="truncate">{patient.address}</span>
                </div>
              )}
            </div>

            {(patient.allergies?.length > 0 || patient.medical_conditions?.length > 0) && (
              <div className="mt-3 flex flex-wrap gap-1">
                {patient.allergies?.map((allergy, index) => (
                  <span key={index} className="px-2 py-1 bg-red-100 text-red-800 text-xs rounded-full">
                    Allergy: {allergy}
                  </span>
                ))}
                {patient.medical_conditions?.map((condition, index) => (
                  <span key={index} className="px-2 py-1 bg-yellow-100 text-yellow-800 text-xs rounded-full">
                    {condition}
                  </span>
                ))}
              </div>
            )}
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default PatientCard;
